import type { TFunction } from 'i18next'
import { isHumanCheckError } from '@/lib/sdk-official/resources/auth'

type Failure = { retryAfter?: number; response?: { status?: number } } | null | undefined

/** SEC-173: the failures of the human check and the attempt limits, which AuthContext passes through untouched. */
export const isAuthGuardFailure = (e: unknown): boolean => {
  const status = (e as Failure)?.response?.status
  return status === 429 || isHumanCheckError(e, 422) || isHumanCheckError(e, 503)
}

/** The text for a login, sign-up or recovery refused by the guard; `null` for any other failure. */
export const authFailureText = (e: unknown, t: TFunction): string | null => {
  const failure = e as Failure
  const status = failure?.response?.status
  if (status === 429) {
    const seconds = failure?.retryAfter
    if (!seconds) return t('auth:guard.tooManyAttempts')
    return seconds < 60
      ? t('auth:guard.tooManyAttemptsSeconds', { count: seconds })
      : t('auth:guard.tooManyAttemptsMinutes', { count: Math.ceil(seconds / 60) })
  }
  if (isHumanCheckError(e, 503)) return t('auth:guard.humanCheckUnavailable')
  if (isHumanCheckError(e, 422)) return t('auth:guard.humanCheckFailed')
  return null
}
